import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { User } from '@/types'

interface AuthState {
  user: User | null
  token: string | null
  loading: boolean
  isLoading: boolean
  error: string | null
  isAuthenticated: boolean
}

const initialState: AuthState = {
  user: null,
  token: localStorage.getItem('auth_token'),
  loading: false,
  isLoading: false,
  error: null,
  isAuthenticated: !!localStorage.getItem('auth_token'),
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true
      state.isLoading = true
      state.error = null
    },
    loginSuccess: (state, action: PayloadAction<any>) => {
      state.user = action.payload.user
      state.token = action.payload.token
      state.isAuthenticated = true
      state.loading = false
      state.isLoading = false
      if (action.payload.token) {
        localStorage.setItem('auth_token', action.payload.token)
      }
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false
      state.isLoading = false
      state.error = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload
      state.isAuthenticated = true
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload
      localStorage.setItem('auth_token', action.payload)
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    logout: (state) => {
      state.user = null
      state.token = null
      state.isAuthenticated = false
      localStorage.removeItem('auth_token')
    },
    // Like logout but doesn't touch localStorage — used when another system
    // (AeThexProvider) is managing the token and will handle storage cleanup.
    clearAuth: (state) => {
      state.user = null
      state.token = null
      state.isAuthenticated = false
    },
  },
})

export const { loginStart, loginSuccess, loginFailure, setLoading, setUser, setToken, setError, logout, clearAuth } = authSlice.actions
export default authSlice.reducer
